//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../no/TaggedObject.js";
import "../no/Expression.js";
import "../Motion/Motion.SelectFieldData.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[1,"Angle",0,"Expression",0],[0,"BankAngleCurve",1,"Motion.MotionFunction",0],[1,"BankAngleCurveProfile",0,"Motion.SelectFieldData",0],[1,"ConstantRadiusBankAngle",0,"Expression",0],[1,"ConstantRadiusElevationChange",0,"Expression",0],[1,"LaneChangeElevationChange",0,"Expression",0],[1,"LaneChangeForwardLength",0,"Expression",0],[1,"LateralAmplitude",0,"Expression",0],[1,"LateralShiftLength",0,"Expression",0],[1,"Length",0,"Expression",0],[0,"Name",1,0],[1,"NumberOfPylons",0,"Expression",0],[1,"Radius",0,"Expression",0],[0,"SegmentType",1,0],[1,"SlalomElevationChange",0,"Expression",0],[1,"SlalomForwardLength",0,"Expression",0],[0,"SplineType",1,0],[1,"StraightElevationChange",0,"Expression",0],[0,"TransitionType",1,0],[0,"YCurve",1,"Motion.MotionFunction",0],[1,"YCurveProfile",0,"Motion.SelectFieldData",0],[0,"ZCurve",1,"Motion.MotionFunction",0],[1,"ZCurveProfile",0,"Motion.SelectFieldData",0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Motion.SegmentBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.SegmentBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.SegmentBuilder.TypeChoices = Object.freeze({
    "Straight" : "Straight", "ConstantRadius" : "ConstantRadius", "LaneChange" : "LaneChange", "Slalom" : "Slalom", "UserDefined" : "UserDefined"});

SPLM.Motion.SegmentBuilder.StraightTransitionTypeChoices = Object.freeze({
    "Linear" : "Linear", "Cubic" : "Cubic"});

SPLM.Motion.SegmentBuilder.SplineDatatypeChoices = Object.freeze({
    "Function" : "Function", "Profile2D" : "Profile2D"});

export default SPLM;